module.exports = __webpack_public_path__ + "media/images/icons/telephone-fill-on-b70277852cbe34c38c55f18464b9fce4.svg";